import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export function LegalLayout({ title, updated, intro, sections }) {
  const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, '-');
  return (
    <div className="bg-paper pb-24 pt-28 lg:pt-36">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-muted transition hover:text-ink">
          <ArrowLeft className="size-4" aria-hidden="true" /> Back to home
        </Link>
        <header className="mt-8 max-w-3xl border-b border-line pb-10">
          <p className="eyebrow">Legal</p>
          <h1 className="mt-4 text-5xl font-normal tracking-[-0.05em] sm:text-6xl">{title}</h1>
          <p className="mt-4 text-sm text-muted">Last updated: {updated}</p>
          {intro && <p className="mt-6 text-[1.05rem] leading-relaxed text-ink-soft">{intro}</p>}
        </header>

        <div className="mt-12 grid gap-12 lg:grid-cols-[220px_1fr] lg:gap-16">
          <nav aria-label="On this page" className="hidden lg:block">
            <ul className="sticky top-28 space-y-2.5 border-l border-line pl-4 text-sm">
              {sections.map((s) => (
                <li key={s.title}>
                  <a href={`#${slug(s.title)}`} className="text-muted transition hover:text-ink">
                    {s.title}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <article className="min-w-0 max-w-3xl space-y-12 break-words">
            {sections.map((s) => (
              <section key={s.title} id={slug(s.title)} className="scroll-mt-28">
                <h2 className="text-2xl font-medium tracking-[-0.03em]">{s.title}</h2>
                <div className="mt-4 space-y-4 text-[0.97rem] leading-relaxed text-ink-soft">
                  {s.blocks.map((b, i) => {
                    if (b.t === 'h3') return <h3 key={i} className="pt-2 text-lg font-semibold text-ink">{b.text}</h3>;
                    if (b.t === 'h4') return <h4 key={i} className="pt-1 font-semibold text-ink">{b.text}</h4>;
                    if (b.t === 'meta') return <p key={i} className="text-sm">{b.text}</p>;
                    if (b.t === 'ul')
                      return (
                        <ul key={i} className="space-y-2.5 pl-1">
                          {b.items.map((item) => (
                            <li key={item} className="flex gap-3">
                              <span className="mt-[0.6rem] size-1.5 shrink-0 rounded-full bg-sage" />
                              <span>{item}</span>
                            </li>
                          ))}
                        </ul>
                      );
                    return <p key={i}>{b.text}</p>;
                  })}
                </div>
              </section>
            ))}
          </article>
        </div>
      </div>
    </div>
  );
}
